(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["veltronics-home"] && !Shopify.designMode) return;
  try {
    
function initVtStory(root=document){root.querySelectorAll('[data-vt-story-carousel]').forEach((c)=>{if(c.dataset.ready)return;c.dataset.ready='1';const track=c.querySelector('[data-vt-story-track]');const slides=[...track.children];const dots=[...c.querySelectorAll('[data-vt-story-dots] button')];let i=0;const show=(n)=>{if(!slides.length)return;i=(n+slides.length)%slides.length;track.scrollTo({left:track.clientWidth*i,behavior:'smooth'});dots.forEach((d,k)=>d.classList.toggle('is-active',k===i))};c.querySelector('[data-vt-story-prev]')?.addEventListener('click',()=>show(i-1));c.querySelector('[data-vt-story-next]')?.addEventListener('click',()=>show(i+1));dots.forEach(d=>d.addEventListener('click',()=>show(Number(d.dataset.index))));let sx=0;track.addEventListener('touchstart',e=>sx=e.touches[0].clientX,{passive:true});track.addEventListener('touchend',e=>{const dx=e.changedTouches[0].clientX-sx;if(Math.abs(dx)>45)show(i+(dx<0?1:-1))},{passive:true})})}document.addEventListener('DOMContentLoaded',()=>initVtStory());document.addEventListener('shopify:section:load',e=>initVtStory(e.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["veltronics-product-offer"] && !Shopify.designMode) return;
  try {
    
function initVtProduct(root=document){root.querySelectorAll('[data-vt-product-offer]').forEach((section)=>{if(section.dataset.ready)return;section.dataset.ready='true';const track=section.querySelector('[data-vtp-track]');const slides=[...section.querySelectorAll('[data-vtp-slide]')];const dots=[...section.querySelectorAll('[data-vtp-dots] button')];let index=0;const show=(next)=>{if(!slides.length)return;index=(next+slides.length)%slides.length;track.style.transform=`translateX(-${index*100}%)`;dots.forEach((d,i)=>d.classList.toggle('is-active',i===index))};section.querySelector('[data-vtp-prev]')?.addEventListener('click',()=>show(index-1));section.querySelector('[data-vtp-next]')?.addEventListener('click',()=>show(index+1));dots.forEach((d)=>d.addEventListener('click',()=>show(Number(d.dataset.index))));let startX=0;section.querySelector('.vt-product__viewport')?.addEventListener('touchstart',(e)=>{startX=e.touches[0].clientX},{passive:true});section.querySelector('.vt-product__viewport')?.addEventListener('touchend',(e)=>{const dx=e.changedTouches[0].clientX-startX;if(Math.abs(dx)>45)show(index+(dx<0?1:-1))},{passive:true})})}document.addEventListener('DOMContentLoaded',()=>initVtProduct());document.addEventListener('shopify:section:load',(e)=>initVtProduct(e.target));

  } catch(e) { console.error(e); }
})();
})();
